import { COLOR } from 'vars/index'

export const OverlayLayoutColors = {
  BANNER_HORIZONTAL_OVERLAY: COLOR.BANNER_HORIZONTAL_OVERLAY,
  BANNER_VERTICAL_OVERLAY: COLOR.BANNER_VERTICAL_OVERLAY,
  CARD_VERTICAL_OVERLAY: COLOR.CARD_VERTICAL_OVERLAY,
  EPISODE_CARD_VERTICAL_OVERLAY: COLOR.EPISODE_CARD_VERTICAL_OVERLAY,
  EVENT_CARD_VERTICAL_OVERLAY: COLOR.EVENT_CARD_VERTICAL_OVERLAY,
  BACKGROUND_VERTICAL_OVERLAY: COLOR.BACKGROUND_VERTICAL_OVERLAY,
  CARD_BOTTOM_OVERLAY: COLOR.MAIN_GRADIENT_0,
  SURFACE_OPACITY_DARK_25: COLOR.SURFACE_OPACITY_DARK_25,
  SURFACE_OPACITY_DARK_40: COLOR.SURFACE_OPACITY_DARK_40,
  MAIN_GRADIENT_0: COLOR.MAIN_GRADIENT_0,
} as const
export type OverlayLayoutColors =
  (typeof OverlayLayoutColors)[keyof typeof OverlayLayoutColors]
